import Vue from 'vue'

export default {
  state: {
    downloadedAlbums: [],
    selectedAlbum: null,
    albumPossiblePlatforms: [
        {
            name: 'Amazon Music',
            id: 1,
            icon: require('@/assets/images/otherPlatforms/amazonMusic.png')
        },
        {
            name: 'iTunes',
            id: 2,
            icon: require('@/assets/images/otherPlatforms/appleMusic.svg')
        },
        {
            name: 'Deezer',
            id: 3,
            icon: require('@/assets/images/otherPlatforms/deezer.svg')
        },
        // {
        //     name: 'Google Music',
        //     id: 4,
        //     icon: require('@/assets/images/otherPlatforms/googleMusic.svg')
        // },
        {
            name: 'SoundCloud',
            id: 5,
            icon: require('@/assets/images/otherPlatforms/soundCloud.svg')
        },
        {
            name: 'Spotify',
            id: 6,
            icon: require('@/assets/images/otherPlatforms/spotify.svg')
        },
        {
            name: 'YouTube Music',
            id: 7,
            icon: require('@/assets/images/otherPlatforms/youtubeMusic.svg')
        },
    ],
  },
  getters: {
    getDownloadedAlbums: state => state.downloadedAlbums,
    getSelectedAlbum: state => state.selectedAlbum,
    getAlbumPossiblePlatforms: state => state.albumPossiblePlatforms,
    getAlbumSpecificPossiblePlatforms: state  => id => state.albumPossiblePlatforms.find(i => i.id == id),
  },
  actions: {
    downloadAlbums: ({commit}, payload) => {
      // payload = {
      //   page:1
      // }
      return Vue.axios.post('album/getAll', payload).then(response => {
        if(response.status == 200){
          commit('SET_DOWNLOADED_ALBUMS', response.data)
          // state.downloadAlbums = response.data
        }
        return response
      }).catch(err => {
        return err
      })
    },
    downloadAlbum: ({commit}, payload) => {
      return Vue.axios.post('album/get/'+payload.id,{
        language: payload.language? payload.language : "pt"
      }).then(response => {
        if(response.status == 200){
          commit('SET_SELECTED_ALBUM', response.data)
          // state.downloadAlbums = response.data
        }
        return response
      }).catch(err => {
        return err
      })
    },
    updateSelectedAlbum: ({commit}, payload) => {
      commit('SET_SELECTED_ALBUM', payload)
    },
    createAlbum: (state ,payload) => {
      return Vue.axios.post('album/create', payload).then(response => {
        return response
      }).catch(err => {
        return err
      })
    },
    saveAlbum: (state , payload) => {
      if(!payload.language){
        payload.language = 'pt'
      }
      return Vue.axios.post('album/update/'+payload.album.id, payload).then(response => {
        return response
      }).catch(err => {
        return err
      })
    },
    deleteAlbum: (state,albumId) => {
      return Vue.axios.post('album/delete/'+albumId).then(response => {
        return response
      }).catch(err => {
        return err
      })
    },
  },
  mutations: {
    SET_DOWNLOADED_ALBUMS: (state, payload) => {
      state.downloadedAlbums = payload
    },
    SET_SELECTED_ALBUM: (state, album) => {
      state.selectedAlbum = album
    },
  },
}
